import * as Types from '../../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type PdfDataFragment = { __typename: 'ConfiguratorPdfData', pdfTemplateUrl?: string | null, fontUrl?: string | null, fontBoldUrl?: string | null, styleSettings?: { __typename: 'PdfStyleSettings', marginTop?: number | null, marginBottom?: number | null, headlineFontSize?: number | null, headlineCharSpacing?: number | null, headlineBold?: boolean | null, headlinePadding?: number | null, imagePadding?: number | null, tableHeaderFontSize?: number | null, tableFontSize?: number | null, tableLineHeight?: number | null, accentColor?: string | null, textColor?: string | null } | null };

export type ConfiguratorDataQueryVariables = Types.Exact<{
  templateId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  templateLegacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sceneLegacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  organizationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  articleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ConfiguratorDataQuery = { __typename: 'Query', configuratorData?: { __typename: 'ConfiguratorTemplate', id: string, organizationId: string, organizationLegacyId: number, articleId?: string | null, latestRevision?: { __typename: 'ConfiguratorTemplateRevision', id: string, graph?: any | null } | null, pdfData: { __typename: 'ConfiguratorPdfData', pdfTemplateUrl?: string | null, fontUrl?: string | null, fontBoldUrl?: string | null, styleSettings?: { __typename: 'PdfStyleSettings', marginTop?: number | null, marginBottom?: number | null, headlineFontSize?: number | null, headlineCharSpacing?: number | null, headlineBold?: boolean | null, headlinePadding?: number | null, imagePadding?: number | null, tableHeaderFontSize?: number | null, tableFontSize?: number | null, tableLineHeight?: number | null, accentColor?: string | null, textColor?: string | null } | null } } | null };

export type ConfiguratorMaterialQueryVariables = Types.Exact<{
  materialId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  materialLegacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  articleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  organizationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ConfiguratorMaterialQuery = { __typename: 'Query', configuratorMaterial?: { __typename: 'ConfiguratorMaterial', id: string, legacyId: number, articleId?: string | null, rangeArticleIds: Array<string>, latestCyclesRevision?: { __typename: 'ConfiguratorMaterialRevision', id: string, legacyId: number } | null } | null };

export type ConfiguratorArDataQueryVariables = Types.Exact<{
  templateRevisionId: Types.Scalars['ID']['input'];
  assignmentKey: Types.Scalars['String']['input'];
}>;


export type ConfiguratorArDataQuery = { __typename: 'Query', configuratorArData?: { __typename: 'ConfiguratorArData', templateId: string, templateLegacyId: number, organizationId: string, organizationLegacyId: number, gltfDataObject?: { __typename: 'ConfiguratorArDataObject', id: string, downloadUrl: string, objectName: string, mediaType?: string | null } | null, usdzDataObject?: { __typename: 'ConfiguratorArDataObject', id: string, downloadUrl: string, objectName: string, mediaType?: string | null } | null } | null };

export type ConfiguratorGenerateArMutationVariables = Types.Exact<{
  input: Types.MutationConfiguratorGenerateArInput;
}>;


export type ConfiguratorGenerateArMutation = { __typename: 'Mutation', configuratorGenerateAr: { __typename: 'ConfiguratorArJob', id: string } };

export type ConfiguratorJobTaskForConfiguratorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfiguratorJobTaskForConfiguratorQuery = { __typename: 'Query', configuratorJobTask?: { __typename: 'ConfiguratorArJobTask', id: string, state: Types.JobState } | null };

export const PdfDataFragmentDoc = gql`
    fragment PdfData on ConfiguratorPdfData {
  pdfTemplateUrl
  fontUrl
  fontBoldUrl
  styleSettings {
    marginTop
    marginBottom
    headlineFontSize
    headlineCharSpacing
    headlineBold
    headlinePadding
    imagePadding
    tableHeaderFontSize
    tableFontSize
    tableLineHeight
    accentColor
    textColor
  }
}
    `;
export const ConfiguratorDataDocument = gql`
    query configuratorData($templateId: ID, $templateLegacyId: Int, $sceneLegacyId: Int, $organizationId: ID, $articleId: String) {
  configuratorData(
    templateId: $templateId
    templateLegacyId: $templateLegacyId
    sceneLegacyId: $sceneLegacyId
    organizationId: $organizationId
    articleId: $articleId
  ) {
    id
    organizationId
    organizationLegacyId
    articleId
    latestRevision {
      id
      graph
    }
    pdfData {
      ...PdfData
    }
  }
}
    ${PdfDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorDataGQL extends Apollo.Query<ConfiguratorDataQuery, ConfiguratorDataQueryVariables> {
    override document = ConfiguratorDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorMaterialDocument = gql`
    query configuratorMaterial($materialId: ID, $materialLegacyId: Int, $articleId: String, $organizationId: ID) {
  configuratorMaterial(
    materialId: $materialId
    materialLegacyId: $materialLegacyId
    articleId: $articleId
    organizationId: $organizationId
  ) {
    id
    legacyId
    articleId
    latestCyclesRevision {
      id
      legacyId
    }
    rangeArticleIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorMaterialGQL extends Apollo.Query<ConfiguratorMaterialQuery, ConfiguratorMaterialQueryVariables> {
    override document = ConfiguratorMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorArDataDocument = gql`
    query configuratorArData($templateRevisionId: ID!, $assignmentKey: String!) {
  configuratorArData(
    templateRevisionId: $templateRevisionId
    assignmentKey: $assignmentKey
  ) {
    templateId
    templateLegacyId
    organizationId
    organizationLegacyId
    gltfDataObject {
      id
      downloadUrl
      objectName
      mediaType
    }
    usdzDataObject {
      id
      downloadUrl
      objectName
      mediaType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorArDataGQL extends Apollo.Query<ConfiguratorArDataQuery, ConfiguratorArDataQueryVariables> {
    override document = ConfiguratorArDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorGenerateArDocument = gql`
    mutation configuratorGenerateAr($input: MutationConfiguratorGenerateArInput!) {
  configuratorGenerateAr(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorGenerateArGQL extends Apollo.Mutation<ConfiguratorGenerateArMutation, ConfiguratorGenerateArMutationVariables> {
    override document = ConfiguratorGenerateArDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfiguratorJobTaskForConfiguratorDocument = gql`
    query configuratorJobTaskForConfigurator($id: ID!) {
  configuratorJobTask(id: $id) {
    id
    state
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfiguratorJobTaskForConfiguratorGQL extends Apollo.Query<ConfiguratorJobTaskForConfiguratorQuery, ConfiguratorJobTaskForConfiguratorQueryVariables> {
    override document = ConfiguratorJobTaskForConfiguratorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }